(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[45580],{

/***/ 91296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 77361:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ MarketMoverBatch; },
/* harmony export */   "M8": function() { return /* binding */ MarketMoverWebsocketRequest; },
/* harmony export */   "Y2": function() { return /* binding */ FilterStocksType; },
/* harmony export */   "pU": function() { return /* binding */ MoverType; }
/* harmony export */ });
/* unused harmony exports MarketMover, MarketMover_NotationDetail, MarketMover_CorpactionDetail, MarketMover_StockDetail, Change, MoverValue */
/* harmony import */ var _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7722);
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/order_trade/entity/v1/market_mover.proto (package financial.order_trade.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum financial.order_trade.entity.v1.MoverType
 */
const MoverType = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeEnum */ .w.makeEnum(
  "financial.order_trade.entity.v1.MoverType",
  [
    {no: 0, name: "MOVER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MOVER_TYPE_TOP_VALUE", localName: "TOP_VALUE"},
    {no: 2, name: "MOVER_TYPE_TOP_VOLUME", localName: "TOP_VOLUME"},
    {no: 3, name: "MOVER_TYPE_TOP_FREQUENCY", localName: "TOP_FREQUENCY"},
    {no: 4, name: "MOVER_TYPE_TOP_GAINER", localName: "TOP_GAINER"},
    {no: 5, name: "MOVER_TYPE_TOP_LOSER", localName: "TOP_LOSER"},
    {no: 6, name: "MOVER_TYPE_NET_FOREIGN_BUY", localName: "NET_FOREIGN_BUY"},
    {no: 7, name: "MOVER_TYPE_NET_FOREIGN_SELL", localName: "NET_FOREIGN_SELL"},
  ],
);

/**
 * @generated from enum financial.order_trade.entity.v1.FilterStocksType
 */
const FilterStocksType = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeEnum */ .w.makeEnum(
  "financial.order_trade.entity.v1.FilterStocksType",
  [
    {no: 0, name: "FILTER_STOCKS_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FILTER_STOCKS_TYPE_MAIN_BOARD", localName: "MAIN_BOARD"},
    {no: 2, name: "FILTER_STOCKS_TYPE_DEVELOPMENT_BOARD", localName: "DEVELOPMENT_BOARD"},
    {no: 3, name: "FILTER_STOCKS_TYPE_ACCELERATION_BOARD", localName: "ACCELERATION_BOARD"},
    {no: 4, name: "FILTER_STOCKS_TYPE_NEW_ECONOMY_BOARD", localName: "NEW_ECONOMY_BOARD"},
    {no: 5, name: "FILTER_STOCKS_TYPE_SPECIAL_MONITORING_BOARD", localName: "SPECIAL_MONITORING_BOARD"},
    {no: 6, name: "FILTER_STOCKS_TYPE_WARRANT_AND_RIGHT", localName: "WARRANT_AND_RIGHT"},
    {no: 7, name: "FILTER_STOCKS_TYPE_SHARIA", localName: "SHARIA"},
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMover
 */
const MarketMover = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "financial.order_trade.entity.v1.MarketMover",
  () => [
    { no: 1, name: "stock_detail", jsonName: "stock_detail", kind: "message", T: MarketMover_StockDetail },
    { no: 2, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "change", kind: "message", T: Change },
    { no: 4, name: "value", kind: "message", T: MoverValue },
    { no: 5, name: "volume", kind: "message", T: MoverValue },
    { no: 6, name: "frequency", kind: "message", T: MoverValue },
    { no: 7, name: "net_foreign_buy", jsonName: "net_foreign_buy", kind: "message", T: MoverValue },
    { no: 8, name: "net_foreign_sell", jsonName: "net_foreign_sell", kind: "message", T: MoverValue },
    { no: 9, name: "net_buy", jsonName: "net_buy", kind: "message", T: MoverValue },
    { no: 10, name: "net_sell", jsonName: "net_sell", kind: "message", T: MoverValue },
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMover.NotationDetail
 */
const MarketMover_NotationDetail = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "financial.order_trade.entity.v1.MarketMover.NotationDetail",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "MarketMover_NotationDetail"},
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMover.CorpactionDetail
 */
const MarketMover_CorpactionDetail = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "financial.order_trade.entity.v1.MarketMover.CorpactionDetail",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "MarketMover_CorpactionDetail"},
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMover.StockDetail
 */
const MarketMover_StockDetail = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "financial.order_trade.entity.v1.MarketMover.StockDetail",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "has_uma", jsonName: "has_uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "notations", kind: "message", T: MarketMover_NotationDetail, repeated: true },
    { no: 6, name: "corpaction", kind: "message", T: MarketMover_CorpactionDetail },
  ],
  {localName: "MarketMover_StockDetail"},
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMoverBatch
 */
const MarketMoverBatch = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "financial.order_trade.entity.v1.MarketMoverBatch",
  () => [
    { no: 1, name: "batch", kind: "message", T: MarketMover, repeated: true },
    { no: 2, name: "mover_type", jsonName: "mover_type", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.getEnumType */ .w.getEnumType(MoverType) },
    { no: 3, name: "filter_stocks", jsonName: "filter_stocks", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.getEnumType */ .w.getEnumType(FilterStocksType), repeated: true },
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.Change
 */
const Change = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "financial.order_trade.entity.v1.Change",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.MoverValue
 */
const MoverValue = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "financial.order_trade.entity.v1.MoverValue",
  () => [
    { no: 1, name: "raw", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "formatted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMoverWebsocketRequest
 */
const MarketMoverWebsocketRequest = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "financial.order_trade.entity.v1.MarketMoverWebsocketRequest",
  () => [
    { no: 1, name: "mover_type", jsonName: "mover_type", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.getEnumType */ .w.getEnumType(MoverType) },
    { no: 2, name: "filter_stocks", jsonName: "filter_stocks", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.getEnumType */ .w.getEnumType(FilterStocksType), repeated: true },
  ],
);



/***/ }),

/***/ 24513:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vC": function() { return /* binding */ WebsocketRequest; },
  "iU": function() { return /* binding */ WebsocketWrapMessageChannel; }
});

// UNUSED EXPORTS: WebsocketChannel

// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/proto3.js + 19 modules
var esm_proto3 = __webpack_require__(7722);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/ping_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/ping.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message securities.transactional.datafeed.v1.PingRequest
 */
const PingRequest = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.PingRequest",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.PingResponse
 */
const PingResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.PingResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/financial/order_trade/entity/v1/market_mover_pb.js
var market_mover_pb = __webpack_require__(77361);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/google/protobuf/timestamp_pb.js
var timestamp_pb = __webpack_require__(27251);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/entity_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/entity.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum securities.transactional.datafeed.v1.Top20Type
 */
const Top20Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.v1.Top20Type",
  [
    {no: 0, name: "TOP20_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 2, name: "TOP20_TYPE_FREQUENCY_RG", localName: "FREQUENCY_RG"},
    {no: 5, name: "TOP20_TYPE_PERCENTAGE_GAINER_RG", localName: "PERCENTAGE_GAINER_RG"},
    {no: 6, name: "TOP20_TYPE_PERCENTAGE_LOSER_RG", localName: "PERCENTAGE_LOSER_RG"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.v1.ErrorCode
 */
const ErrorCode = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.v1.ErrorCode",
  [
    {no: 0, name: "ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 400, name: "ERROR_CODE_BAD_REQUEST", localName: "BAD_REQUEST"},
    {no: 401, name: "ERROR_CODE_UNAUTHORIZED", localName: "UNAUTHORIZED"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.v1.TradeType
 */
const TradeType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.v1.TradeType",
  [
    {no: 0, name: "TRADE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TRADE_TYPE_BUY", localName: "BUY"},
    {no: 2, name: "TRADE_TYPE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Bid
 */
const Bid = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.Bid",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Offer
 */
const Offer = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.Offer",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Change
 */
const Change = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.Change",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Error
 */
const Error = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.Error",
  () => [
    { no: 1, name: "code", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ErrorCode) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/running_trade_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/running_trade.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from message securities.transactional.datafeed.v1.RunningTrade
 */
const RunningTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.RunningTrade",
  () => [
    { no: 1, name: "websocket_time", jsonName: "websocket_time", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "stock", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "volume", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "action", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(TradeType) },
    { no: 6, name: "is_global", jsonName: "is_global", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "time", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 8, name: "change", kind: "message", T: Change },
    { no: 9, name: "trade_number", jsonName: "trade_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.RunningTradeBatch
 */
const RunningTradeBatch = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.RunningTradeBatch",
  () => [
    { no: 1, name: "batch", kind: "message", T: RunningTrade, repeated: true },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/financial/emitten/entity/v1/fr_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/emitten/entity/v1/fr.proto (package financial.emitten.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum financial.emitten.entity.v1.FRBadges
 */
const FRBadges = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.emitten.entity.v1.FRBadges",
  [
    {no: 0, name: "FR_BADGES_UNSPECIFIED"},
    {no: 1, name: "FR_BADGES_TOP_SHORT_TERM"},
    {no: 2, name: "FR_BADGES_HIGHEST_YIELD"},
  ],
);

/**
 * @generated from message financial.emitten.entity.v1.FRAttributes
 */
const fr_pb_FRAttributes = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v1.FRAttributes",
  () => [
    { no: 1, name: "bid_price", jsonName: "bid_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offer_price", jsonName: "offer_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "due_date", jsonName: "due_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "performance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "yield", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "badges", kind: "enum", T: proto3.getEnumType(FRBadges), repeated: true },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v1.FRfitem
 */
const FRfitem = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v1.FRfitem",
  () => [
    { no: 1, name: "annual_coupon_rate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "due_date", jsonName: "due_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "minimum_order", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "next_coupon_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "coupon_distribution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "issued_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "bid_price", jsonName: "bid_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "offer_price", jsonName: "offer_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "performance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "yield", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v1.FRDetail
 */
const FRDetail = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v1.FRDetail",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_syariah", jsonName: "is_syariah", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "coupon_rate", jsonName: "coupon_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "due_date", jsonName: "due_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "publish_date", jsonName: "publish_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "publisher", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "coupon_returned_date", jsonName: "coupon_returned_date", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "min_order", jsonName: "min_order", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "order_multiples", jsonName: "order_multiples", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "memo_url", jsonName: "memo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "vcon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v1.FRPrice
 */
const FRPrice = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v1.FRPrice",
  () => [
    { no: 1, name: "buy_price_rate", jsonName: "buy_price_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "buy_yield", jsonName: "buy_yield", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "sell_price_rate", jsonName: "sell_price_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "sell_yield", jsonName: "sell_yield", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "return_rate", jsonName: "return_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "indicative_buy", jsonName: "indicative_buy", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "indicative_sell", jsonName: "indicative_sell", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "accrued_interest", jsonName: "accrued_interest", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "cumulative_accrued_interest", jsonName: "cumulative_accrued_interest", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "basis_point", jsonName: "basis_point", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "basis_percentage", jsonName: "basis_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/financial/emitten/entity/v1/extra_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/emitten/entity/v1/extra.proto (package financial.emitten.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * ExtraAttributes used to return extra attributes of each company type
 * because each company type has different attributes
 * e.g for Stock, they have Price while for Mutual Fund, they have NAV
 * This is to prepare for future company type that has different attributes (scalable)
 *
 * @generated from message financial.emitten.entity.v1.ExtraAttributes
 */
const extra_pb_ExtraAttributes = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v1.ExtraAttributes",
  () => [
    { no: 1, name: "fr_attributes", jsonName: "fr_attributes", kind: "message", T: FRAttributes, oneof: "extra" },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/financial/emitten/entity/v2/company_detail_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/emitten/entity/v2/company_detail.proto (package financial.emitten.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from enum financial.emitten.entity.v2.FRStatus
 */
const FRStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.emitten.entity.v2.FRStatus",
  [
    {no: 0, name: "FR_STATUS_UNSPECIFIED"},
    {no: 1, name: "FR_STATUS_ACTIVE"},
    {no: 2, name: "FR_STATUS_MATURED"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.SortOrder
 */
const SortOrder = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.emitten.entity.v2.SortOrder",
  [
    {no: 0, name: "SORT_ORDER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SORT_ORDER_ASC", localName: "ASC"},
    {no: 2, name: "SORT_ORDER_DESC", localName: "DESC"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.Status
 */
const Status = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.emitten.entity.v2.Status",
  [
    {no: 0, name: "STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 1, name: "STATUS_SUSPENDED", localName: "SUSPENDED"},
    {no: 2, name: "STATUS_DELISTED", localName: "DELISTED"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.StatusV2
 */
const StatusV2 = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.emitten.entity.v2.StatusV2",
  [
    {no: 0, name: "STATUS_V2_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_V2_ACTIVE", localName: "ACTIVE"},
    {no: 2, name: "STATUS_V2_SUSPENDED", localName: "SUSPENDED"},
    {no: 3, name: "STATUS_V2_DELISTED", localName: "DELISTED"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.CompanyType
 */
const CompanyType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.emitten.entity.v2.CompanyType",
  [
    {no: 0, name: "COMPANY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMPANY_TYPE_SAHAM", localName: "SAHAM"},
    {no: 2, name: "COMPANY_TYPE_INDEX", localName: "INDEX"},
    {no: 3, name: "COMPANY_TYPE_FX", localName: "FX"},
    {no: 4, name: "COMPANY_TYPE_ETF", localName: "ETF"},
    {no: 5, name: "COMPANY_TYPE_INDEX_ASING", localName: "INDEX_ASING"},
    {no: 6, name: "COMPANY_TYPE_COMMODITIES", localName: "COMMODITIES"},
    {no: 7, name: "COMPANY_TYPE_CRYPTO", localName: "CRYPTO"},
    {no: 8, name: "COMPANY_TYPE_WARAN", localName: "WARAN"},
    {no: 9, name: "COMPANY_TYPE_RIGHT", localName: "RIGHT"},
    {no: 10, name: "COMPANY_TYPE_REKSADANA", localName: "REKSADANA"},
    {no: 11, name: "COMPANY_TYPE_OBLIGASI", localName: "OBLIGASI"},
    {no: 12, name: "COMPANY_TYPE_DIRE", localName: "DIRE"},
    {no: 13, name: "COMPANY_TYPE_FR", localName: "FR"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.Exchange
 */
const Exchange = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.emitten.entity.v2.Exchange",
  [
    {no: 0, name: "EXCHANGE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EXCHANGE_IDX", localName: "IDX"},
    {no: 2, name: "EXCHANGE_KLSE", localName: "KLSE"},
    {no: 3, name: "EXCHANGE_SGX", localName: "SGX"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.StockType
 */
const StockType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.emitten.entity.v2.StockType",
  [
    {no: 0, name: "STOCK_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STOCK_TYPE_COMMON", localName: "COMMON"},
    {no: 2, name: "STOCK_TYPE_PREFERRED", localName: "PREFERRED"},
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.EmittenInfoData
 */
const EmittenInfoData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenInfoData",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "catalogs", kind: "message", T: Catalog, repeated: true },
    { no: 7, name: "tags", kind: "message", T: EmittenTag, repeated: true },
    { no: 8, name: "tradable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "company_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "metadata", kind: "message", T: EmittenMetadata, repeated: true },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.EmittenMetadata
 */
const EmittenMetadata = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenMetadata",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.EmittenTag
 */
const EmittenTag = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenTag",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.Stock
 */
const Stock = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.Stock",
  () => [
    { no: 1, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "last", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "company_id", jsonName: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "notation", kind: "message", T: Notation, repeated: true },
    { no: 10, name: "uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "corp_action", jsonName: "corp_action", kind: "message", T: CorpAction },
    { no: 15, name: "isexist", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 17, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "is_following", jsonName: "is_following", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "formatted_price", jsonName: "formatted_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "is_exists", jsonName: "is_exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.CorpAction
 */
const CorpAction = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "financial.emitten.entity.v2.CorpAction",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.Notation
 */
const Notation = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "financial.emitten.entity.v2.Notation",
  () => [
    { no: 1, name: "notation_code", jsonName: "notation_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "notation_desc", jsonName: "notation_desc", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon_url", jsonName: "icon_url", kind: "message", T: IconURL },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.IconURL
 */
const IconURL = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "financial.emitten.entity.v2.IconURL",
  () => [
    { no: 1, name: "light_mode", jsonName: "light_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dark_mode", jsonName: "dark_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.DayTradeInfo
 */
const DayTradeInfo = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.DayTradeInfo",
  () => [
    { no: 1, name: "is_show_multiplier", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "multiplier", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.TradingLimitInfo
 */
const TradingLimitInfo = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.TradingLimitInfo",
  () => [
    { no: 1, name: "is_trading_limit", jsonName: "is_trading_limit", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "haircut_percentage", jsonName: "haircut_percentage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.CompanyPageInfo
 */
const CompanyPageInfo = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyPageInfo",
  () => [
    { no: 1, name: "aum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "average", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "followed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "followers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "indexes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "orderbook", kind: "message", T: OrderTrade },
    { no: 14, name: "percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "prices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 18, name: "sector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "sentiment", kind: "message", T: Sentiments },
    { no: 20, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 21, name: "sub_sector", jsonName: "sub_sector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "tabs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 26, name: "time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "type_company", jsonName: "type_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "volume", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 32, name: "market_hour", jsonName: "market_hour", kind: "message", T: MarketHour },
    { no: 33, name: "is_holding_exist", jsonName: "is_holding_exist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 34, name: "formatted_price", jsonName: "formatted_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "is_price_alert_exist", jsonName: "is_price_alert_exist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 36, name: "notation", kind: "message", T: Notation, repeated: true },
    { no: 37, name: "trade_type", jsonName: "trade_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "catalogs", kind: "message", T: Catalog, repeated: true },
    { no: 39, name: "indexes_data", jsonName: "indexes_data", kind: "message", T: IndexesInfo, repeated: true },
    { no: 40, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "corp_action", jsonName: "corp_action", kind: "message", T: CorpAction },
    { no: 42, name: "uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 43, name: "day_trade_multiplier", jsonName: "day_trade_multiplier", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 44, name: "day_trade_info", jsonName: "day_trade_info", kind: "message", T: DayTradeInfo },
    { no: 45, name: "trading_limit_info", jsonName: "trading_limit_info", kind: "message", T: TradingLimitInfo },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.Catalog
 */
const Catalog = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.Catalog",
  () => [
    { no: 1, name: "company_symbol", jsonName: "company_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "catalog_name", jsonName: "catalog_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "company_type", jsonName: "company_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "show", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.IndexesInfo
 */
const IndexesInfo = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.IndexesInfo",
  () => [
    { no: 1, name: "company_symbol", jsonName: "company_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company_type", jsonName: "company_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.MarketHour
 */
const MarketHour = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.MarketHour",
  () => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "time_left", jsonName: "time_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "formatted_time_left", jsonName: "formatted_time_left", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "suspend_info", jsonName: "suspend_info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.OrderPriceVol
 */
const OrderPriceVol = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.OrderPriceVol",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "volume", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.OrderTrade
 */
const OrderTrade = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.OrderTrade",
  () => [
    { no: 1, name: "bid", kind: "message", T: OrderPriceVol },
    { no: 2, name: "offer", kind: "message", T: OrderPriceVol },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.Sentiments
 */
const Sentiments = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.Sentiments",
  () => [
    { no: 1, name: "end_value", jsonName: "end_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_value", jsonName: "start_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.SectorCatalog
 */
const SectorCatalog = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.SectorCatalog",
  () => [
    { no: 1, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "total_stock", jsonName: "total_stock", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.PopularStock
 */
const PopularStock = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.PopularStock",
  () => [
    { no: 1, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_following", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_exists", jsonName: "is_exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.Company
 */
const Company = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.Company",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.SectorSubsectorCompany
 */
const SectorSubsectorCompany = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.SectorSubsectorCompany",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "alias1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.CompanyInIndustry
 */
const CompanyInIndustry = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyInIndustry",
  () => [
    { no: 1, name: "avgvolume", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "company_id", jsonName: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "followed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "followers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "isexist", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "last", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "marketcap", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "popularity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "type_company", jsonName: "type_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "valuema20", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "volume", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "formatted_price", jsonName: "formatted_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "is_exists", jsonName: "is_exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.ListDiscover
 */
const ListDiscover = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.ListDiscover",
  () => [
    { no: 1, name: "company_id", jsonName: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "last", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "isexist", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "notation", kind: "message", T: Notation, repeated: true },
    { no: 11, name: "uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "corp_action", jsonName: "corp_action", kind: "message", T: CorpAction },
    { no: 13, name: "is_exists", jsonName: "is_exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "extra_attributes", jsonName: "extra_attributes", kind: "message", T: ExtraAttributes },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.ListFinancialDiscover
 */
const ListFinancialDiscover = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.ListFinancialDiscover",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "companies", kind: "message", T: ListDiscover, repeated: true },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.CompanyDetail
 */
const CompanyDetail = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyDetail",
  () => [
    { no: 1, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.CompanyContact
 */
const CompanyContact = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyContact",
  () => [
    { no: 1, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_followed", jsonName: "is_followed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "thumb", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.GetCompanyDataCatalog
 */
const GetCompanyDataCatalog = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.GetCompanyDataCatalog",
  () => [
    { no: 1, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "previous", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "last", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.GetCompanyCatalog
 */
const GetCompanyCatalog = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.GetCompanyCatalog",
  () => [
    { no: 1, name: "pchange_info", jsonName: "pchange_info", kind: "message", T: GetCompanyDataCatalog, repeated: true },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.EmittenList
 */
const EmittenList = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenList",
  () => [
    { no: 1, name: "emitten_results", jsonName: "emitten_results", kind: "message", T: EmittenResult, repeated: true },
    { no: 2, name: "paginate", kind: "message", T: PaginateDetails },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.EmittenResult
 */
const EmittenResult = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenResult",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subsector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status_text", jsonName: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "share_outstanding", jsonName: "share_outstanding", kind: "message", T: ShareOutstanding },
    { no: 11, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "indexes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "listing_boards", jsonName: "listing_boards", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.ShareOutstanding
 */
const ShareOutstanding = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.ShareOutstanding",
  () => [
    { no: 1, name: "raw", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "formatted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.DetailCompany
 */
const DetailCompany = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.DetailCompany",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "symbol", kind: "message", T: Symbol },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(CompanyType) },
    { no: 4, name: "sector", kind: "message", T: Sector },
    { no: 5, name: "sub_sector", jsonName: "sub_sector", kind: "message", T: Sector },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(StatusV2) },
    { no: 10, name: "share_outstanding", jsonName: "share_outstanding", kind: "message", T: ShareOutstanding },
    { no: 11, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.CompanyBasicInfo
 */
const CompanyBasicInfo = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyBasicInfo",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_tradable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "instrument_type", jsonName: "instrument_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "notations", kind: "message", T: Notation, repeated: true },
    { no: 13, name: "status", kind: "enum", T: proto3.getEnumType(StatusV2) },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.Sector
 */
const Sector = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.Sector",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.Symbol
 */
const Symbol = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.Symbol",
  () => [
    { no: 1, name: "quote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticker", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.SectorCompanyResult
 */
const SectorCompanyResult = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.SectorCompanyResult",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "alias1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.TypeCompanyResult
 */
const TypeCompanyResult = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.TypeCompanyResult",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.StatusCompanyResult
 */
const StatusCompanyResult = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.StatusCompanyResult",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.emitten.entity.v2.ListComponentCompany
 */
const ListComponentCompany = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.emitten.entity.v2.ListComponentCompany",
  () => [
    { no: 1, name: "sectors", kind: "message", T: SectorCompanyResult, repeated: true },
    { no: 2, name: "types", kind: "enum", T: proto3.getEnumType(CompanyType), repeated: true },
    { no: 3, name: "countries", kind: "message", T: TypeCompanyResult, repeated: true },
    { no: 4, name: "statuses", kind: "enum", T: proto3.getEnumType(StatusV2), repeated: true },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/hotlist_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/hotlist.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from message securities.transactional.datafeed.v1.Hotlist
 */
const Hotlist = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.Hotlist",
  () => [
    { no: 1, name: "stock_symbol", jsonName: "stock_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last_price", jsonName: "last_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "change", kind: "message", T: Change },
    { no: 4, name: "uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "corp_action", jsonName: "corp_action", kind: "message", T: CorpAction },
    { no: 6, name: "notations", kind: "message", T: Notation, repeated: true },
    { no: 7, name: "stock_name", jsonName: "stock_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Top20
 */
const Top20 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.Top20",
  () => [
    { no: 1, name: "hotlist", kind: "message", T: Hotlist, repeated: true },
    { no: 2, name: "time", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Top20Type) },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/watchlist_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/watchlist.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from message securities.transactional.datafeed.v1.Watchlist
 */
const Watchlist = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.Watchlist",
  () => [
    { no: 1, name: "stock_symbol", jsonName: "stock_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last_price", jsonName: "last_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "change", kind: "message", T: Change },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/orderbook_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/orderbook.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from message securities.transactional.datafeed.v1.OrderBookHeader
 */
const OrderBookHeader = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.OrderBookHeader",
  () => [
    { no: 1, name: "stock_symbol", jsonName: "stock_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "change", kind: "message", T: Change },
    { no: 3, name: "price", kind: "message", T: Price },
    { no: 4, name: "time", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.OrderBookBody
 */
const OrderBookBody = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.OrderBookBody",
  () => [
    { no: 1, name: "stock_symbol", jsonName: "stock_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bid", kind: "message", T: Bid, repeated: true },
    { no: 3, name: "offer", kind: "message", T: Offer, repeated: true },
    { no: 4, name: "time", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.Price
 */
const Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.Price",
  () => [
    { no: 1, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "high", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "low", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "avg", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "last", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "prev", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "frequency", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "fbuy", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "fsell", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "val", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/consumer/entity/v1/entity_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/consumer/entity/v1/entity.proto (package securities.transactional.datafeed.consumer.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.HotlistType
 */
const HotlistType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.HotlistType",
  [
    {no: 0, name: "HOTLIST_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "HOTLIST_TYPE_TOP_GAINER", localName: "TOP_GAINER"},
    {no: 2, name: "HOTLIST_TYPE_TOP_LOSER", localName: "TOP_LOSER"},
    {no: 3, name: "HOTLIST_TYPE_MOST_ACTIVE", localName: "MOST_ACTIVE"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.BoardType
 */
const BoardType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.BoardType",
  [
    {no: 0, name: "BOARD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "BOARD_TYPE_RG", localName: "RG"},
    {no: 2, name: "BOARD_TYPE_TN", localName: "TN"},
    {no: 3, name: "BOARD_TYPE_NG", localName: "NG"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.Source
 */
const Source = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.Source",
  [
    {no: 0, name: "SOURCE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SOURCE_ITCH", localName: "ITCH"},
    {no: 2, name: "SOURCE_IMQ", localName: "IMQ"},
    {no: 3, name: "SOURCE_CRYPTO", localName: "CRYPTO"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.SuspendState
 */
const SuspendState = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.SuspendState",
  [
    {no: 0, name: "SUSPEND_STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SUSPEND_STATE_UNSUSPENDED", localName: "UNSUSPENDED"},
    {no: 2, name: "SUSPEND_STATE_SUSPENDED", localName: "SUSPENDED"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.AuctionCrossType
 */
const AuctionCrossType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.AuctionCrossType",
  [
    {no: 0, name: "AUCTION_CROSS_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "AUCTION_CROSS_TYPE_OPENING", localName: "OPENING"},
    {no: 2, name: "AUCTION_CROSS_TYPE_INTRADAY", localName: "INTRADAY"},
    {no: 3, name: "AUCTION_CROSS_TYPE_CLOSING", localName: "CLOSING"},
    {no: 4, name: "AUCTION_CROSS_TYPE_CALL", localName: "CALL"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.OrderType
 */
const OrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_BID", localName: "BID"},
    {no: 2, name: "ORDER_TYPE_OFFER", localName: "OFFER"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.OrderStatus
 */
const OrderStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.OrderStatus",
  [
    {no: 0, name: "ORDER_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_STATUS_OPEN", localName: "OPEN"},
    {no: 2, name: "ORDER_STATUS_PARTIAL_MATCH", localName: "PARTIAL_MATCH"},
    {no: 3, name: "ORDER_STATUS_FULL_MATCH", localName: "FULL_MATCH"},
    {no: 4, name: "ORDER_STATUS_AMEND", localName: "AMEND"},
    {no: 5, name: "ORDER_STATUS_WITHDRAW", localName: "WITHDRAW"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.ListingBoardType
 */
const ListingBoardType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.ListingBoardType",
  [
    {no: 0, name: "LISTING_BOARD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LISTING_BOARD_TYPE_MAIN_BOARD", localName: "MAIN_BOARD"},
    {no: 2, name: "LISTING_BOARD_TYPE_DEVELOPMENT_BOARD", localName: "DEVELOPMENT_BOARD"},
    {no: 3, name: "LISTING_BOARD_TYPE_ACCELERATION_BOARD", localName: "ACCELERATION_BOARD"},
    {no: 4, name: "LISTING_BOARD_TYPE_SPECIAL_MONITORING_BOARD", localName: "SPECIAL_MONITORING_BOARD"},
    {no: 5, name: "LISTING_BOARD_TYPE_NEW_ECONOMY_BOARD", localName: "NEW_ECONOMY_BOARD"},
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Change
 */
const entity_pb_Change = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Change",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.BestOrder
 */
const BestOrder = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.BestOrder",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Company
 */
const entity_pb_Company = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Company",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sector", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "sub_sector", jsonName: "sub_sector", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "latest_price", jsonName: "latest_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "latest_numshare", jsonName: "latest_numshare", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "default_currency", jsonName: "default_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "tz", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "trade_type", jsonName: "trade_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "isin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "sedol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "tradable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "sector_name", jsonName: "sector_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "sub_sector_name", jsonName: "sub_sector_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "instrument", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "remarks_short", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "remarks_long", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "special_notation_codes", jsonName: "special_notation_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 25, name: "listing_board", jsonName: "listing_board", kind: "enum", T: proto3.getEnumType(ListingBoardType) },
    { no: 26, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Sector
 */
const entity_pb_Sector = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Sector",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parent", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "disabled", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "alias1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "alias2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "market_id", jsonName: "market_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "global_sector_id", jsonName: "global_sector_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "parent_name", jsonName: "parent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Hotlist
 */
const entity_pb_Hotlist = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Hotlist",
  () => [
    { no: 1, name: "stocks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(HotlistType) },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Intraday
 */
const Intraday = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Intraday",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "high", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "low", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "close", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "volume", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "change", kind: "message", T: entity_pb_Change },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.LivePrice
 */
const LivePrice = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.LivePrice",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastprice", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "volume", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "high", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "low", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "frequency", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "frg_buy", jsonName: "frg_buy", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "frg_sell", jsonName: "frg_sell", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "average", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "close", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "prev", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "change", kind: "message", T: entity_pb_Change },
    { no: 16, name: "order_verb", jsonName: "order_verb", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 18, name: "is_index", jsonName: "is_index", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "order_number", jsonName: "order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 22, name: "match_number", jsonName: "match_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 23, name: "board", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(BoardType) },
    { no: 24, name: "source", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Source) },
    { no: 25, name: "switch_reset", jsonName: "switch_reset", kind: "message", T: SwitchReset },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Orderbook
 */
const Orderbook = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Orderbook",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "source", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Source) },
    { no: 7, name: "switch_reset", jsonName: "switch_reset", kind: "message", T: SwitchReset },
    { no: 8, name: "board", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(BoardType) },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.IEPIEV
 */
const IEPIEV = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.IEPIEV",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "iep", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "iev", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "auction_cross_type", jsonName: "auction_cross_type", kind: "enum", T: proto3.getEnumType(AuctionCrossType) },
    { no: 7, name: "best_bid", jsonName: "best_bid", kind: "message", T: BestOrder },
    { no: 8, name: "best_offer", jsonName: "best_offer", kind: "message", T: BestOrder },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.SwitchReset
 */
const SwitchReset = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.SwitchReset",
  () => [
    { no: 1, name: "from", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Source) },
    { no: 2, name: "to", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Source) },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "datetime", jsonName: "date_time", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.CompanyTradingAction
 */
const CompanyTradingAction = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.CompanyTradingAction",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "trading_state", jsonName: "trading_state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "formatted_time", jsonName: "formatted_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "board_type", jsonName: "board_type", kind: "enum", T: proto3.getEnumType(BoardType) },
    { no: 10, name: "suspend_state", jsonName: "suspend_state", kind: "enum", T: proto3.getEnumType(SuspendState) },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.OrderDetail
 */
const OrderDetail = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.OrderDetail",
  () => [
    { no: 1, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "board_type", jsonName: "board_type", kind: "enum", T: proto3.getEnumType(BoardType) },
    { no: 4, name: "order_type", jsonName: "order_type", kind: "enum", T: proto3.getEnumType(OrderType) },
    { no: 5, name: "order_status", jsonName: "order_status", kind: "enum", T: proto3.getEnumType(OrderStatus) },
    { no: 6, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "formatted_time", jsonName: "formatted_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "order_number", jsonName: "order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "exchange_order_number", jsonName: "exchange_order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "total_quantity", jsonName: "total_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "open_quantity", jsonName: "open_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.AccountRegistration
 */
const AccountRegistration = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.AccountRegistration",
  () => [
    { no: 1, name: "account_id", jsonName: "account_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "approved_by_cs", jsonName: "approved_by_cs", kind: "message", T: ApprovedByCS },
    { no: 3, name: "closed_date", jsonName: "closed_date", kind: "message", T: Timestamp },
    { no: 4, name: "completed_date", jsonName: "completed_date", kind: "message", T: Timestamp },
    { no: 5, name: "created_date", jsonName: "created_date", kind: "message", T: Timestamp },
    { no: 8, name: "partner", kind: "message", T: Partner },
    { no: 9, name: "securities_id", jsonName: "securities_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "status_kyc", jsonName: "status_kyc", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.ApprovedByCS
 */
const ApprovedByCS = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.ApprovedByCS",
  () => [
    { no: 1, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "actor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "actor_username", jsonName: "actor_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "updated_date", jsonName: "updated_date", kind: "message", T: Timestamp },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Partner
 */
const Partner = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Partner",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.OrderCancel
 */
const OrderCancel = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.OrderCancel",
  () => [
    { no: 1, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "order_number", jsonName: "order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "order_verb", jsonName: "order_verb", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "formatted_time", jsonName: "formatted_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "exchange_order_number", jsonName: "exchange_order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "board_type", jsonName: "board_type", kind: "enum", T: proto3.getEnumType(BoardType) },
  ],
)));

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.IndexMember
 */
const IndexMember = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.IndexMember",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "index_code", jsonName: "index_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timestamp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "switch_reset", jsonName: "switch_reset", kind: "message", T: SwitchReset },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/financial/company_price_feed/entity/v2/indicative_price_volume_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/company_price_feed/entity/v2/indicative_price_volume.proto (package financial.company_price_feed.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message financial.company_price_feed.entity.v2.IEPIEV
 */
const indicative_price_volume_pb_IEPIEV = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "financial.company_price_feed.entity.v2.IEPIEV",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "iep", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "iev", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/financial/company_price_feed/entity/v1/indicative_price_volume_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/company_price_feed/entity/v1/indicative_price_volume.proto (package financial.company_price_feed.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum financial.company_price_feed.entity.v1.Status
 */
const indicative_price_volume_pb_Status = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "financial.company_price_feed.entity.v1.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_OPEN", localName: "OPEN"},
    {no: 2, name: "STATUS_CLOSE", localName: "CLOSE"},
  ],
);

/**
 * @generated from message financial.company_price_feed.entity.v1.IEPIEV
 */
const v1_indicative_price_volume_pb_IEPIEV = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.company_price_feed.entity.v1.IEPIEV",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(indicative_price_volume_pb_Status) },
    { no: 3, name: "iep", kind: "message", T: Value },
    { no: 4, name: "iev", kind: "message", T: Value },
    { no: 5, name: "time_left_seconds", jsonName: "time_left_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "best_bid_offer", jsonName: "best_bid_offer", kind: "message", T: BestBidOffer },
    { no: 7, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message financial.company_price_feed.entity.v1.BestBidOffer
 */
const BestBidOffer = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "financial.company_price_feed.entity.v1.BestBidOffer",
  () => [
    { no: 1, name: "bid", kind: "message", T: indicative_price_volume_pb_BestOrder },
    { no: 2, name: "offer", kind: "message", T: indicative_price_volume_pb_BestOrder },
    { no: 3, name: "time_left_seconds", jsonName: "time_left_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message financial.company_price_feed.entity.v1.BestOrder
 */
const indicative_price_volume_pb_BestOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "financial.company_price_feed.entity.v1.BestOrder",
  () => [
    { no: 1, name: "price", kind: "message", T: Value },
    { no: 2, name: "quantity", kind: "message", T: Value },
    { no: 3, name: "change_percentage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.company_price_feed.entity.v1.Value
 */
const Value = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "financial.company_price_feed.entity.v1.Value",
  () => [
    { no: 1, name: "raw", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "formatted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.company_price_feed.entity.v1.BestBidOfferWS
 */
const BestBidOfferWS = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "financial.company_price_feed.entity.v1.BestBidOfferWS",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "best_bid", jsonName: "best_bid", kind: "message", T: indicative_price_volume_pb_BestOrder },
    { no: 4, name: "best_offer", jsonName: "best_offer", kind: "message", T: indicative_price_volume_pb_BestOrder },
    { no: 5, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/websocket_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/websocket.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck













/**
 * @generated from message securities.transactional.datafeed.v1.WebsocketRequest
 */
const WebsocketRequest = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.WebsocketRequest",
  () => [
    { no: 1, name: "user_id", jsonName: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel", kind: "message", T: WebsocketChannel },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ping", kind: "message", T: PingRequest },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.WebsocketChannel
 */
const WebsocketChannel = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.WebsocketChannel",
  () => [
    { no: 1, name: "watchlist", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "order_book", jsonName: "order_book", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "running_trade", jsonName: "running_trade", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "is_hotlist", jsonName: "is_hotlist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "running_trade_batch", jsonName: "running_trade_batch", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "liveprice", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "iepiev", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "intraday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "best_bid_offer", jsonName: "best_bid_offer", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "market_mover", jsonName: "market_mover", kind: "message", T: market_mover_pb/* MarketMoverWebsocketRequest */.M8, repeated: true },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.WebsocketWrapMessageChannel
 */
const WebsocketWrapMessageChannel = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.transactional.datafeed.v1.WebsocketWrapMessageChannel",
  () => [
    { no: 1, name: "running_trade", jsonName: "running_trade", kind: "message", T: RunningTrade, oneof: "message_channel" },
    { no: 2, name: "ping", kind: "message", T: PingResponse, oneof: "message_channel" },
    { no: 3, name: "top20", kind: "message", T: Top20, oneof: "message_channel" },
    { no: 4, name: "watchlist", kind: "message", T: Watchlist, oneof: "message_channel" },
    { no: 5, name: "orderbook_header", jsonName: "orderbook_header", kind: "message", T: OrderBookHeader, oneof: "message_channel" },
    { no: 6, name: "orderbook_body", jsonName: "orderbook_body", kind: "message", T: OrderBookBody, oneof: "message_channel" },
    { no: 7, name: "error", kind: "message", T: Error, oneof: "message_channel" },
    { no: 8, name: "running_trade_batch", jsonName: "running_trade_batch", kind: "message", T: RunningTradeBatch, oneof: "message_channel" },
    { no: 9, name: "liveprice", kind: "message", T: LivePrice, oneof: "message_channel" },
    { no: 10, name: "orderbook", kind: "message", T: Orderbook, oneof: "message_channel" },
    { no: 11, name: "iepiev", kind: "message", T: indicative_price_volume_pb_IEPIEV, oneof: "message_channel" },
    { no: 12, name: "intraday", kind: "message", T: Intraday, oneof: "message_channel" },
    { no: 13, name: "best_bid_offer", jsonName: "best_bid_offer", kind: "message", T: BestBidOfferWS, oneof: "message_channel" },
    { no: 14, name: "market_mover_batch", jsonName: "market_mover_batch", kind: "message", T: market_mover_pb/* MarketMoverBatch */.CA, oneof: "message_channel" },
  ],
);



/***/ })

}]);